import { z } from "zod";

export const AddCommandeDTOQuerySchema = z.object({
  villeLivraison: z
    .string({
      required_error: "Le champ ville de livraison est requis.",
      invalid_type_error:
        "La ville de livraison doit être une chaîne de caractères.",
    })
    .min(1, "Le champ ville de livraison ne peut pas être vide."),
  detailAdresse: z
    .string({
      required_error: "Le champ détail de l'adresse est requis.",
      invalid_type_error:
        "Le détail de l'adresse doit être une chaîne de caractères.",
    })
    .min(1, "Le champ détail de l'adresse ne peut pas être vide."),
  dfs: z
    .string({
      required_error: "Le champ DFS est requis.",
      invalid_type_error: "Le DFS doit être une chaîne de caractères.",
    })
    .min(1, "Le champ DFS ne peut pas être vide."),
  commentaire: z
    .string({
      required_error: "Le champ commentaire est requis.",
      invalid_type_error: "Le commentaire doit être une chaîne de caractères.",
    })
    .min(1, "Le champ commentaire ne peut pas être vide."),
  infosLot: z
    .array(
      z.object({
        ville: z
          .string({
            required_error: "Le champ ville est requis.",
            invalid_type_error: "La ville doit être une chaîne de caractères.",
          })
          .min(1, "Le champ ville ne peut pas être vide.")
          .trim(),
        nblots: z
          .number({
            required_error: "Le champ nombre de lots est requis.",
            invalid_type_error: "Le nombre de lots doit être un nombre.",
          })
          .min(1, "Le champ nombre de lots doit être supérieur à 0.")
          .int("Le nombre de lots doit être un nombre entier."),
      })
    )
    .min(1, "Au moins un lot doit être spécifié.")
    .refine(
      (infos) => infos.every((info) => info.ville && info.ville.trim() !== ""),
      {
        message: "Toutes les villes doivent être renseignées et non vides.",
      }
    )
    .refine((infos) => infos.every((info) => info.nblots && info.nblots > 0), {
      message:
        "Tous les nombres de lots doivent être renseignés et supérieurs à 0.",
    })
    .refine(
      (infos) => {
        const villes = infos.map((info) => info.ville.trim().toLowerCase());
        return villes.length === new Set(villes).size;
      },
      {
        message: "Les villes ne peuvent pas être dupliquées.",
      }
    ),
  referenceCampagne: z
    .string({
      required_error: "Le champ référence de la campagne est requis.",
      invalid_type_error:
        "La référence de la campagne doit être une chaîne de caractères.",
    })
    .min(1, "Le champ référence de la campagne ne peut pas être vide."),
});
